import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import WordColourPicker from './WordColourPicker.js'
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import Badge from '@material-ui/core/Badge';
import { observer, inject } from 'mobx-react';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import ChooseWordDialog from './components/ChooseWordDialog.js';
import InstructionsDialog from './components/InstructionsDialog.js';
import ConfirmDeleteDialog from './components/ConfirmDeleteDialog.js';
import CannotDeleteSetWordDialog from './components/CannotDeleteSetWordDialog.js';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    chip: {
        margin: theme.spacing.unit,
    },
    wordDisplay: {
        textAlign: 'center',
        overflow: 'hidden',
        marginBottom: 16,
        backgroundColor: '#f0f0f0'
    },
    addWordButton: {
        marginBottom: 20,
        marginLeft: 20
    },
    floatingHelpButton: {
        position: 'fixed',
        top: 0,
        right: 0
    }
});


@inject( 'wcpStore' )
@observer
class WordDisplay extends Component {

    constructor(props) {
        super(props);
        this.fontSize = 200;
        this.state = {
            wordIndex: 0,
            word: this.props.wcpStore.wordList[0],
            chooseWordDialogOpen: false,
            instructionsOpen: true,
            confirmDeleteWord: '',
            cannotDeleteSetWordDialogOpen: false
        }
    }

    handleChooseWordClick = () => {

        if (!this.props.wcpStore.allWordsAdded()) {
            this.props.wcpStore.addNextWord();
        } else {
            // open choose own word dialog - DISABLED
            //            this.setState({
            //chooseWordDialogOpen: true
            //});

        }

        // go to newly added word
        this.handleClick(this.props.wcpStore.wordList.length - 1);
    };

    handleCloseChooseWordDialog = () => {
        this.setState({
            chooseWordDialogOpen: false
        });
    };

    handleClick = (index) => {
        this.setState({
            wordIndex: index,
            word: this.props.wcpStore.wordList[index]
        });

    };

    handleChange = (wordSettings) => {
        this.props.wcpStore.setWordSettings(this.state.word, wordSettings);
    };

    handleDelete = wordToDelete => () => {
        // check if word is set
        const wordIsSet = this.props.wcpStore.getWordLockedStatus(this.state.word);

        if (wordIsSet) {
            this.setState({
                cannotDeleteSetWordDialogOpen: true
            })
        } else {
            this.setState({
                confirmDeleteWord: wordToDelete
            })
        }
    };

    confirmDelete = () => {

        // If deleting selected word, have to move selection
        if (this.state.word == this.state.confirmDeleteWord) {
            this.setState({
                wordIndex: 0,
                word: this.props.wcpStore.wordList[0]
            });
        }

        this.props.wcpStore.removeWord(this.state.confirmDeleteWord);
        this.setState({
            confirmDeleteWord: ''
        });
    };

    closeCannotDeleteSetWordDialog = () => {
        this.setState({
            cannotDeleteSetWordDialogOpen: false
        });
    }

    cancelDelete = () => {
        this.setState({
            confirmDeleteWord: ''
        });
    }

    handleResetColoursClick = () => {
        this.markWordUnset();
        let letterSettings = this.props.wcpStore.resetWordSettings(this.props.wcpStore.wordList[this.state.wordIndex]);

    };

    handleModalInstructionsClose = () => {
        this.setState({
            instructionsOpen: false,
        });
    };

    helpButtonClicked = () => {
        this.setState({
            instructionsOpen: true,
        });
    }

    markWordSet = () => {
        const word = this.props.wcpStore.wordList[this.state.wordIndex];
        this.props.wcpStore.setWordLocked(word, true);
    }

    markWordUnset = () => {
        const word = this.props.wcpStore.wordList[this.state.wordIndex];
        this.props.wcpStore.setWordLocked(word, false);
    }


    render() {
        const { classes } = this.props;
        const { wordList, letterColours } = this.props.wcpStore;
        const { instructionsOpen,confirmDeleteWord,cannotDeleteSetWordDialogOpen } = this.state;

        const word = wordList[this.state.wordIndex];
        const wordIsSet = this.props.wcpStore.getWordLockedStatus(word);
        const showButton = this.props.wcpStore.allWordsLocked();
        const letterSettings = this.props.wcpStore.getLetterSettings(word);
        return (
            <div>

                {!instructionsOpen && <div className={classes.floatingHelpButton}>
                    <IconButton color="secondary"
                                onClick={this.helpButtonClicked}
                        >
                        <InfoIcon />
                    </IconButton>
                </div>}


            <InstructionsDialog open={instructionsOpen} step={2} handleClose={this.handleModalInstructionsClose} />
            <ConfirmDeleteDialog open={confirmDeleteWord !== ''} wordToDelete={confirmDeleteWord} handleCancel={this.cancelDelete} handleDelete={this.confirmDelete} />
            <CannotDeleteSetWordDialog open={cannotDeleteSetWordDialogOpen} handleOk={this.closeCannotDeleteSetWordDialog} />
                <div className={classes.root}>
                    {

                        wordList.map((word,index) => {

                            const invisible = !this.props.wcpStore.getWordLockedStatus(word);

                            return(
                                <Badge color="primary" variant="dot" className={classes.chip} invisible={invisible} >
                                    <Chip
                                        key={index}
                                        label={word}
                                        onClick={() => {this.handleClick(index)}}

                                        variant="outlined"
                                        onDelete={index > 2 ? this.handleDelete(word) : null }
                                    />
                                </Badge>)
                        })
                    }
                {showButton && <Badge color="secondary" variant="dot" className={classes.chip} invisible={true} >
                    <Chip icon={<AddIcon />} label="Add Word" onClick={this.handleChooseWordClick} />
                </Badge>}


                </div>

                {wordList.length !== 0 &&
                    <><Paper className={classes.wordDisplay} >
                        <WordColourPicker fontSize={this.fontSize}
                                                word={word}
                                                canEdit={!wordIsSet}
                                                letterColours={letterColours}
                                                letterSettings={letterSettings}
                                                onChange={this.handleChange}
                                                {...this.props}/>

                    </Paper>
                    { !wordIsSet && <Button variant="contained" color="primary" className={classes.addWordButton} onClick={this.markWordSet}>
                        Set Word
                    </Button>}
                    { wordIsSet && <Button variant="contained" className={classes.addWordButton} onClick={this.markWordUnset}>
                        Unset Word
                    </Button>}
                    { !wordIsSet && <Button variant="contained" color="secondary" className={classes.addWordButton} onClick={this.handleResetColoursClick}>
                    Reset Colours
                    </Button>}</>}
                <hr/>

            <ChooseWordDialog open={this.state.chooseWordDialogOpen} onClose={this.handleCloseChooseWordDialog}/>
            </div>
        );
    }
}

export default withStyles(styles)(WordDisplay);
